import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spotlightTitle: {
		id: 'issue-navigator-filters-menu.FiltersMenuOnboarding.messages.spotlight-title',
		defaultMessage: 'Finding and creating saved filters just got easier',
		description:
			'Title for the onboarding spotlight of the new saved filters menu in List (All work) view.',
	},
	spotlightBody: {
		id: 'issue-navigator-filters-menu.FiltersMenuOnboarding.messages.spotlight-body',
		defaultMessage: "Find filters you've saved, and save new ones in one place.",
		description:
			'Body for the onboarding spotlight of the new saved filters menu in List (All work) view.',
	},
	spotlightDismissButton: {
		id: 'issue-navigator-filters-menu.FiltersMenuOnboarding.messages.spotlight-dismiss-button',
		defaultMessage: 'OK',
		description: 'Label for dismiss button to close the spotlight.',
	},
});
